import { useGetFamilies } from "modules/family/api";
import { FamilyWithMembers } from "modules/family/types/family.interface";
import { useCallback, useMemo, useState } from "react";
import FamilyTable, { RowObjFamily } from "../default/components/familyTable";

const Families = () => {
  const [searchName, setSearchName] = useState<string | undefined>(undefined);
  const { data, hasNextPage, fetchNextPage, fetchPreviousPage, isLoading } =
    useGetFamilies(searchName, 20);
  const [currentPage, setCurrentPage] = useState(1);

  // Memoize the current page data
  const flatData = useMemo(
    () => data?.pages[currentPage - 1]?.data ?? [],
    [data?.pages, currentPage]
  );

  // Memoize the formatted data
  const formattedData = useMemo((): RowObjFamily[] => {
    return flatData.map((item: FamilyWithMembers) => ({
      id: item._id,
      name: item.name,
      description: item.description || "",
      memberCount: item.members?.length || 0,
      totalAmountDue: item.totalAmountDue || 0,
      totalAmountPaid: item.totalAmountPaid || 0,
    }));
  }, [flatData]);

  const handleFetchNextPage = useCallback(() => {
    if (hasNextPage) {
      fetchNextPage();
      setCurrentPage((prev) => prev + 1);
    }
  }, [hasNextPage, fetchNextPage]);

  const handleFetchPrevPage = useCallback(() => {
    if (currentPage > 1) {
      fetchPreviousPage();
      setCurrentPage((prev) => prev - 1);
    }
  }, [currentPage, fetchPreviousPage]);

  const totalPage = data?.pages[0]?.count
    ? Math.ceil(data.pages[0].count / 20)
    : 1;

  return (
    <div>
      <div className="mt-5">
        <FamilyTable
          tableData={formattedData}
          searchName={searchName || ""}
          setSearchName={setSearchName}
          currentPage={currentPage}
          totalPage={totalPage}
          hasNextPage={hasNextPage}
          handleFetchNextPage={handleFetchNextPage}
          handleFetchPrevPage={handleFetchPrevPage}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default Families;
